<template>
  <div
    :class="dense ? '' : 'page-container'"
    :style="dense ? `height: ${height}` : ''"
    v-if="deluge">
    <v-dialog
      max-width="600"
      v-model="preview_dialog"
      class="template-pop-up template-pop-up-fix">
      <CreateAsset
        v-if="preview_dialog"
        v-on:close="preview_dialog = false" />
    </v-dialog>

    <!-- Create Asset Group Dialog -->
    <v-dialog
      v-model="create_group_dialog"
      class="template-pop-up template-pop-up-fix">
      <CreateAssetGroupDialog
        v-if="create_group_dialog"
        :open="create_group_dialog"
        :title="groupDialogTitle"
        :subtitle="groupDialogSubtitle"
        :confirm-label="groupDialogConfirmLabel"
        :show-description="groupDialogShowDescription"
        :context-message="groupDialogContextMessage"
        :loading="createGroupLoading"
        :initial-name="groupDialogInitialName"
        :initial-description="groupDialogInitialDescription"
        @close="handleGroupDialogClose"
        @submit="handleGroupDialogSubmit" />
    </v-dialog>
    <v-dialog
      class="template-pop-up template-pop-up-fix"
      v-model="asset_info_dialog">
      <EditAssetModal
        v-if="asset_info_dialog && !overrideModalCondition"
        v-on:close="asset_info_dialog = false"
        :selected="selected"></EditAssetModal>
      <slot
        v-else-if="asset_info_dialog && overrideModalCondition"
        :selected="selected"></slot>
    </v-dialog>

    <!-- Edit Asset Group Modal -->
    <v-dialog
      class="template-pop-up template-pop-up-fix"
      v-model="group_info_dialog">
      <EditAssetGroupModal
        v-if="group_info_dialog"
        v-on:close="group_info_dialog = false"
        v-on:refresh="searchQueryUpdated"
        v-on:open-asset="openAssetFromGroup"
        :selected="selected_group"></EditAssetGroupModal>
    </v-dialog>

    <!-- Deleted Assets Modal -->
    <v-dialog
      class="template-pop-up template-pop-up-fix"
      v-model="deleted_assets_dialog"
      max-width="700">
      <DeletedAssetsModal
        v-if="deleted_assets_dialog"
        @close="deleted_assets_dialog = false"
        @restored="searchQueryUpdated" />
    </v-dialog>

    <!-- upload/filter/search bar -->
    <div
      style="display: flex"
      :class="dense ? '' : 'mb-4 mt-2 mx-5'">
      <input
        accept=".mp4, .mov, .ts, .mkv, .avi, .png, .jpeg, .jpg, .dds, .wmv, .wma, .asf, .ogg, .flv, .mpeg, .mpg, .f4v, .m2ts, .vob, .webm, .bmp, .json, .mp3, .wav, .aac, .flac, .m4a"
        type="file"
        style="display: none"
        multiple
        id="asset_file_upload"
        @input="send_to_upload_queue()" />
      <v-btn
        v-if="!dense"
        style="align-items: center"
        variant="flat"
        height="40px"
        color="var(--v-cardColor-base)"
        class="px-2 d-flex align-center mr-2 subtleshadow top-bar-buttons"
        @click="open_file_dialog()"
        title="Upload Asset">
        <v-icon>mdi-upload-outline</v-icon>
      </v-btn>

      <v-btn
        v-if="!dense"
        style="align-items: center"
        variant="flat"
        height="40px"
        color="var(--v-cardColor-base)"
        class="px-2 d-flex align-center mr-2 subtleshadow top-bar-buttons"
        @click="preview_dialog = true"
        title="Add a Live Stream, Video Feed, NDI, Text or JSON Asset">
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <v-btn
        v-if="!dense"
        style="align-items: center"
        variant="flat"
        height="40px"
        color="var(--v-cardColor-base)"
        class="px-2 d-flex align-center mr-2 subtleshadow top-bar-buttons"
        @click="createNewGroup"
        title="Create Asset Group">
        <v-icon>mdi-folder-multiple-plus</v-icon>
      </v-btn>

      <v-btn
        v-if="!dense"
        style="align-items: center"
        variant="flat"
        height="40px"
        color="var(--v-cardColor-base)"
        class="px-2 d-flex align-center mr-2 subtleshadow top-bar-buttons"
        @click="deleted_assets_dialog = true"
        title="View Deleted Assets">
        <v-icon>mdi-delete-restore</v-icon>
      </v-btn>

      <v-spacer v-if="!dense" />
      <v-text-field
        v-if="showSearchBar"
        v-model="search"
        density="compact"
        append-inner-icon="mdi-magnify"
        single-line
        class="subtleshadow"
        hide-details
        variant="solo"
        :placeholder="`Search Assets...`"
        @input="user_search(searchQueryUpdated)"
        rounded
        autofocus
        style="border-radius: 5px !important; max-width: 880px"
        bg-color="var(--v-cardColor-base) !important"
        color="var(--text) !important"></v-text-field>
      <v-select
        v-if="showSearchBar"
        label="Sort By"
        class="subtleshadow ml-2"
        density="compact"
        variant="solo"
        hide-details
        item-title="display_name"
        item-value="value"
        return-object
        rounded
        v-model="sortBy"
        style="border-radius: 5px !important; max-width: 160px"
        bg-color="var(--v-cardColor-base) !important"
        color="var(--text) !important"
        :items="[
          { display_name: 'Time Created', value: 'timestamp' },
          { display_name: 'Name', value: 'name' },
        ]"></v-select>
      <v-select
        v-if="showSearchBar"
        label="Show"
        class="subtleshadow ml-2"
        density="compact"
        variant="solo"
        hide-details
        item-title="display_name"
        item-value="value"
        return-object
        rounded
        v-model="showFilter"
        @update:modelValue="searchQueryUpdated()"
        style="border-radius: 5px !important; max-width: 160px"
        bg-color="var(--v-cardColor-base) !important"
        color="var(--text) !important"
        :items="[
          { display_name: 'All', value: 'all' },
          { display_name: 'Assets Only', value: 'assets' },
          { display_name: 'Groups Only', value: 'groups' },
        ]"></v-select>
      <v-btn
        v-if="showSearchBar"
        style="align-items: center"
        variant="flat"
        height="40px"
        color="var(--v-cardColor-base)"
        class="px-2 d-flex align-center ml-2 subtleshadow top-bar-buttons"
        @click="
          order = order === 'asc' ? 'desc' : 'asc';
          searchQueryUpdated();
        "
        :title="
          order === 'asc'
            ? 'Change to Sort Descending'
            : 'Change to Sort Ascending'
        ">
        <v-icon v-if="order === 'asc'">mdi-sort-ascending</v-icon>
        <v-icon v-if="order === 'desc'">mdi-sort-descending</v-icon>
      </v-btn>
      <v-btn
        v-if="showSearchBar && !dense && !selectMode"
        variant="flat"
        height="40px"
        color="var(--v-cardColor-base)"
        class="ml-2 subtleshadow top-bar-buttons"
        :loading="selectAllLoading"
        @click="handleSelectAllByFilter"
        title="Select All">
        <v-icon>mdi-select-all</v-icon>
      </v-btn>
      <v-progress-linear
        v-if="!dense"
        :active="waitForLoad"
        :model-value="loadNum"
        color="primary"
        absolute
        height="4"></v-progress-linear>
    </div>

    <!-- Breadcrumb Navigation -->
    <div
      v-if="!dense && breadcrumbs.length > 1"
      class="mx-5 mb-3 d-flex align-center">
      <v-btn
        icon
        size="small"
        variant="text"
        class="mr-2"
        @click="navigateBack"
        title="Go back">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-breadcrumbs
        :items="breadcrumbs"
        class="pa-0">
        <template v-slot:prepend>
          <v-icon
            size="small"
            class="mr-2">
            mdi-folder-open
          </v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            @click="navigateToGroup(item.uid)"
            :disabled="item.uid === current_group"
            style="cursor: pointer">
            {{ item.name }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>

    <!-- Selection Banner (shows when non-visible items are selected) -->
    <SelectionBanner
      v-if="!dense && !selectMode"
      :total-selected="filterSelection.selectedUids.value.length"
      :visible-count="filterSelection.visibleSelectedCount.value"
      :non-visible-count="filterSelection.nonVisibleSelectedCount.value"
      item-type="assets"
      @clear="handleClearFilterSelection" />

    <!-- Bulk Delete Confirmation Dialog -->
    <BulkConfirmDialog
      :open="bulkDeleteDialogOpen"
      title="Delete Selected Assets"
      :message="`Are you sure you want to delete ${selected_assets.length} asset(s)?`"
      confirm-label="Delete"
      confirm-color="error"
      icon="mdi-trash-can"
      icon-color="error"
      :total-count="selected_assets.length"
      :non-visible-count="filterSelection.nonVisibleSelectedCount.value"
      item-type="assets"
      :loading="multi_delete_loading"
      @close="bulkDeleteDialogOpen = false"
      @confirm="confirmBulkDelete" />

    <div
      class="assets-container"
      :style="'max-height: ' + containerHeight">
      <TagsViewer
        v-if="showTags"
        :dense="dense"
        @select="searchQueryUpdated()"
        :tags="deluge.tags"
        :filterByTag="selected_filters" />
      <transition name="slide-fade">
        <MultiAssetSelection
          v-if="selected_assets.length > 0 && !selectMode"
          @cancelledOrCompleted="handleClearFilterSelection"
          @group-requested="openGroupDialogFromSelection"
          :multi_delete_loading="multi_delete_loading"
          :multi_delete_func="handleBulkDeleteWithConfirmation"
          :selected_assets="selected_assets"
          :shift_click_started="shift_click_started"
          :has-non-visible-selected="filterSelection.hasNonVisibleSelected.value"
          :non-visible-count="filterSelection.nonVisibleSelectedCount.value" />
      </transition>
      <!-- Custom layer transition system - all layers exist simultaneously -->
      <div class="assets-layers-container">
        <div
          v-for="(layer, index) in breadcrumb_layers"
          :key="index"
          class="assets-layer"
          :class="{
            'layer-active': index === current_layer_index,
            'layer-left': index < current_layer_index,
            'layer-right': index > current_layer_index,
            'layer-transitioning': is_transitioning,
          }"
          :style="{
            zIndex:
              index === current_layer_index
                ? 10
                : index < current_layer_index
                  ? 5
                  : 15,
          }">
          <div
            v-if="
              Object.keys(layer.assets?.assets || layer.assets || {})
                .length === 0
            "
            class="no-results-message"
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: 200px;
              opacity: 0.5;
              user-select: none;
            ">
            <v-icon
              size="48"
              style="opacity: 0.4"
              class="mb-3">
              mdi-magnify-close
            </v-icon>
            <span style="font-size: 14px">No matching assets found</span>
          </div>
          <v-infinite-scroll
            v-else
            :key="`scroll-${index}-${scrollResetKey}`"
            :height="dense ? '100%' : `calc(100vh - 240px)`"
            :margin="250"
            @load="
              (event) => {
                if (index === current_layer_index) loadMore(event);
                else event.done('ok');
              }
            ">
            <v-virtual-scroll
              :height="dense ? '100%' : `calc(100vh - 240px)`"
              width="100%"
              :item-height="dense ? 97 : 110"
              :renderless="true"
              :items="
                Object.values(layer.assets?.assets || layer.assets || {}).sort(
                  (a, b) => {
                    return (a.index ?? 0) - (b.index ?? 0);
                  }
                )
              ">
              <template v-slot:default="{ item }">
                <!-- Asset Group Card -->
                <WideCard
                  v-if="item.type === 'asset_group'"
                  :dense="dense"
                  @click="
                    selectMode
                      ? assetSelectModeClick(item)
                      : editAssetGroup(item)
                  "
                  @thumbnail-click="openAssetGroup(item)"
                  :class="dense ? 'mr-2' : 'mx-5'"
                  :tag="true"
                  :loading="false"
                  :thumbnails="formatGroupThumbnails(item.thumbnails)"
                  :title="item.name"
                  :icon="
                    !item.thumbnails || item.thumbnails.length === 0
                      ? 'mdi-folder-multiple'
                      : null
                  "
                  :selected="selected_assets.includes(item.uid)"
                  :icons="[{ icon: 'mdi-folder-multiple' }]"
                  :tooltip="`Asset Group: ${item.asset_count} asset(s)`">
                  <Tag
                    v-if="item.src_uid"
                    icon="mdi-cloud-sync-outline"
                    name="Omni"
                    color="#4a5899" />
                  <Tag
                    v-if="item.origin === 'player'"
                    icon="mdi-server-network"
                    name="On Player"
                    color="#5b6f7f" />
                  <Tag
                    v-for="(tag, i) in item.tags"
                    :key="(tag, i)"
                    :color="get_color_safe(deluge.tags[tag])"
                    :icon="deluge.tags[tag]?.icon"
                    :name="get_name_safe(deluge.tags[tag])" />
                </WideCard>

                <!-- Regular Asset Card -->
                <WideCard
                  v-else
                  :dense="dense"
                  @click="
                    selectMode
                      ? assetSelectModeClick(item)
                      : asset_click_handle(item)
                  "
                  :class="dense ? 'mr-2' : 'mx-5'"
                  :tag="true"
                  :loading="item.ready !== true"
                  :img="assetSmallThumbnail(item)"
                  :vid="assetSmallThumbnail(item, 'motion')"
                  :title="item.name"
                  :icon="iconByType(item.asset_type)"
                  :selected="selected_assets.includes(item.uid)"
                  :icons="getAssetIcons(item)"
                  tooltip="Open asset details"
                  :NDIName="item.asset_type == 'ndi' ? item.value : null">
                  <Tag
                    v-if="item.src_uid"
                    icon="mdi-cloud-sync-outline"
                    name="Omni"
                    color="#4a5899" />
                  <Tag
                    v-if="item.origin === 'player'"
                    icon="mdi-server-network"
                    name="On Player"
                    color="#5b6f7f" />
                  <Tag
                    v-for="(tag, i) in item.tags"
                    :key="(tag, i)"
                    :color="get_color_safe(deluge.tags[tag])"
                    :icon="deluge.tags[tag]?.icon"
                    :name="get_name_safe(deluge.tags[tag])" />
                </WideCard>
              </template>
            </v-virtual-scroll>
          </v-infinite-scroll>
        </div>
      </div>
    </div>

    <!-- <v-virtual-scroll
      height="calc(100vh - 160px)"
      width="100%"
      item-height="124"
      :items="assets">
      <template v-slot:default="{ item }"></template>
    </v-virtual-scroll> -->
  </div>
</template>
<script setup>
import WideCard from '../Shared/WideCard.vue';
import MultiAssetSelection from './MultiAssetSelection.vue';
import Tag from '../Shared/Tag.vue';
import { user_search, loadNum, waitForLoad } from '../../utils/pseudoLoader.js';
import { $http } from '../../stores/http.js';
import { deluge } from '@/stores/deluge.js';
import { state } from '../../stores/deluge.js';
import { onMounted, onUnmounted, ref, watch, computed, onBeforeMount, nextTick } from 'vue';
import { defineProps } from 'vue';
import CreateAsset from './CreateAsset.vue';
import TagsViewer from '../Shared/TagsViewer.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';
import { iconByType } from '../../utils/assetTypeToMDIIcon.js';
import { applyPatch } from 'rfc6902';
import { selectWithModifiers } from '@/utils/selectionRange.js';
import EditAssetModal from './EditAssetModal.vue';
import EditAssetGroupModal from './EditAssetGroupModal.vue';
import { assetSmallThumbnail } from '../../utils/thumbnails.js';
import CreateAssetGroupDialog from './CreateAssetGroupDialog.vue';
import DeletedAssetsModal from './DeletedAssetsModal.vue';
import SelectionBanner from '../Shared/SelectionBanner.vue';
import BulkConfirmDialog from '../Shared/BulkConfirmDialog.vue';
import { useFilterSelection } from '../../composables/useFilterSelection.js';

const ctrl_down = ref(false);
const shift_down = ref(false);

watch(
  () => state.ctrl_down,
  (newVal) => {
    ctrl_down.value = newVal;
  }
);
watch(
  () => state.shift_down,
  (newVal) => {
    shift_down.value = newVal;
  }
);

// Filter selection composable for "Select All by Filter" functionality
const filterSelection = useFilterSelection('assets');
const bulkDeleteDialogOpen = ref(false);
const selectAllLoading = ref(false);

const props = defineProps({
  height_adjust: { type: Number, default: 0 },
  overrideModalCondition: {
    type: Boolean,
    default: false,
  },
  forceClose: {
    type: Boolean,
    default: false,
  },
  dense: {
    type: Boolean,
    default: false,
  },
  height: {
    type: String,
    default: '100%',
  },
  selectMode: {
    type: Boolean,
    default: false,
  },
  showTags: {
    type: Boolean,
    default: true,
  },
  showSearchBar: {
    type: Boolean,
    default: true,
  },
  searchQuery: {
    type: String,
    default: '',
  },
  returnObject: {
    type: Boolean,
    default: false,
  },
  tagQuery: {
    type: Object,
    default: () => ({ include: [], require: [] }),
  },
  excludeUids: {
    type: Array,
    default: () => [],
  },
  containerHeight: {
    type: String,
    default: 'calc(105vh - 240px)',
  },
});

const search = ref(props.searchQuery || '');
// Incremented on every search/filter change to force v-infinite-scroll to re-mount
// and reset its internal loading/empty state.
const scrollResetKey = ref(0);

watch(
  () => props.searchQuery,
  (newVal) => {
    search.value = newVal;
    user_search(searchQueryUpdated);
  }
);
const sortBy = ref({ display_name: 'Time Created', value: 'timestamp' });
const order = ref('desc');
const showFilter = ref({ display_name: 'All', value: 'all' });

function buildIncludeFilterParams() {
  return {
    includeAssets: showFilter.value.value === 'groups' ? 'false' : 'true',
    includeGroups: showFilter.value.value === 'assets' ? 'false' : 'true',
  };
}

// Computed property to filter assets based on showFilter
const filteredAssets = computed(() => {
  // Safety check: ensure assets.value.assets exists and is an object
  if (!assets.value?.assets || typeof assets.value.assets !== 'object') {
    return {};
  }

  const allAssets = assets.value.assets;

  if (showFilter.value.value === 'all') {
    return allAssets;
  } else if (showFilter.value.value === 'assets') {
    // Show only regular assets (filter out groups)
    return Object.fromEntries(
      Object.entries(allAssets).filter(
        ([uid, item]) => item.type !== 'asset_group'
      )
    );
  } else if (showFilter.value.value === 'groups') {
    // Show only asset groups
    return Object.fromEntries(
      Object.entries(allAssets).filter(
        ([uid, item]) => item.type === 'asset_group'
      )
    );
  }
  return allAssets;
});

function assetSelectModeClick(item) {
  // Support ctrl-click and shift-click range selection when in select mode
  const result = selectWithModifiers({
    itemsMap: assets.value.assets,
    selected: selected_assets.value,
    clickedUid: item.uid,
    ctrlDown: ctrl_down.value,
    shiftDown: shift_down.value,
    shiftAnchor: shift_click_started,
    selectMultiple: true,
  });

  selected_assets.value = result.selected;
  shift_click_started = result.shiftAnchor;

  if (!props.returnObject) {
    emit('selected', selected_assets.value); // return uid
  } else {
    const selected_assets_objects = selected_assets.value.map((uid) => {
      return assets.value.assets[uid];
    });
    emit('selected', selected_assets_objects);
  }
}
const requiredTags = ref([]);
// Declare selected_filters before any watcher that uses it (watchers with immediate:true run during setup)
const selected_filters = ref([]);
onMounted(() => {
  selected_filters.value = props.tagQuery?.include || [];
  requiredTags.value = props.tagQuery?.require || [];

  // Load initial assets for first layer
  searchQueryUpdated();

  // Sync current view state when layer changes - setup in onMounted to avoid initialization issues
  watch(current_layer_index, (newIndex) => {
    if (breadcrumb_layers.value[newIndex]) {
      assets.value = breadcrumb_layers.value[newIndex].assets;
      showFilter.value = breadcrumb_layers.value[newIndex].filter;
      search.value = breadcrumb_layers.value[newIndex].search;
    }
  });

});

// Debug watcher for filter changes (doesn't access filteredAssets computed, avoids circular dependency)
watch(
  () => showFilter.value?.value,
  (newFilter) => {
    console.log('[showFilter] Filter changed to:', newFilter);
    console.log(
      '[showFilter] Total unfiltered asset count:',
      Object.keys(assets.value?.assets || {}).length
    );
  }
);

watch(
  () => props.tagQuery,
  () => {
    selected_filters.value = props.tagQuery?.include || [];
    requiredTags.value = props.tagQuery?.require || [];

    searchQueryUpdated();
  },
  { deep: true, immediate: false }
);
watch(sortBy, () => {
  searchQueryUpdated();
});

const assets = ref({ assets: {} });
async function searchQueryUpdated() {
  // Emit loading state
  emit('loading', true);
  const { includeAssets, includeGroups } = buildIncludeFilterParams();
  const new_assets = JSON.parse(
    await $http(
      'GET',
      `/get_assets?limit=30&offset=0&search_query=${
        search.value
      }&filter_tags=${selected_filters.value.join(',')}&sort_by=${
        sortBy.value.value
      }_${order.value}&required_tags=${requiredTags.value.join(
        ','
      )}&exclude_uids=${props.excludeUids.join(
        ','
      )}&group_uid=${current_group.value || ''}&include_assets=${includeAssets}&include_groups=${includeGroups}`
    )
  );
  assets.value.assets = new_assets;

  // Update current layer cache with loaded assets
  breadcrumb_layers.value[current_layer_index.value] = {
    assets: { ...assets.value },
    filter: { ...showFilter.value },
    search: search.value,
  };

  // Reset the v-infinite-scroll AFTER data is committed so the fresh
  // instance sees the current results and correctly signals empty/ok.
  scrollResetKey.value++;

  // Emit results count and loading complete
  emit('results-count', Object.keys(new_assets).length);
  emit('loading', false);

  // Auto-fill: If we got items but viewport might not be filled, trigger another load
  // This handles cases where the initial 30 items don't fill the scrollable area
  // The loadMore function will call done('empty') if there's no more data
  await nextTick();
  if (
    Object.keys(new_assets).length > 0 &&
    Object.keys(new_assets).length === 30
  ) {
    // Check if there might be more items - schedule a check for auto-load
    checkAndAutoFillViewport();
  }
}
async function loadMore(resp) {
  // Calculate offset based only on assets (type !== 'asset_group') for accurate pagination
  // Groups are loaded separately and not paginated on the backend
  const currentAssets = assets.value?.assets || {};
  const totalItems = Object.keys(currentAssets).length;

  // If the initial search/filter returned 0 items, signal empty immediately
  // to prevent the v-infinite-scroll from spinning indefinitely.
  if (totalItems === 0) {
    resp.done('empty');
    return;
  }

  const assetOnlyCount = Object.values(currentAssets).filter(
    (item) => item.type !== 'asset_group'
  ).length;

  console.log(
    '[loadMore] Called with asset-only offset:',
    assetOnlyCount,
    'total items:',
    totalItems
  );
  console.log('[loadMore] Current filter:', showFilter.value);

  const { includeAssets, includeGroups } = buildIncludeFilterParams();
  const new_assets = JSON.parse(
    await $http(
      'GET',
      `/get_assets?limit=30&offset=${assetOnlyCount}&search_query=${search.value}&filter_tags=${selected_filters.value.join(
        ','
      )}&sort_by=${sortBy.value.value}_${
        order.value
      }&required_tags=${requiredTags.value.join(
        ','
      )}&exclude_uids=${props.excludeUids.join(
        ','
      )}&group_uid=${current_group.value || ''}&include_assets=${includeAssets}&include_groups=${includeGroups}`
    )
  );

  console.log(
    '[loadMore] Received',
    Object.values(new_assets).length,
    'new assets from backend'
  );

  // Initialize assets.value.assets if it doesn't exist
  if (!assets.value.assets) {
    assets.value.assets = {};
  }

  const previousCount = Object.keys(assets.value.assets).length;
  assets.value.assets = { ...assets.value.assets, ...new_assets };
  const currentCount = Object.keys(assets.value.assets).length;

  console.log(
    '[loadMore] Total assets before:',
    previousCount,
    'after:',
    currentCount
  );

  // CRITICAL: Sync to breadcrumb_layers so v-virtual-scroll sees the new items
  // The virtual scroll reads from breadcrumb_layers, not assets.value directly
  if (
    breadcrumb_layers.value &&
    breadcrumb_layers.value[current_layer_index.value]
  ) {
    breadcrumb_layers.value[current_layer_index.value] = {
      ...breadcrumb_layers.value[current_layer_index.value],
      assets: { ...assets.value },
    };
  }

  // Check if backend returned no new assets
  if (Object.values(new_assets).length === 0) {
    console.log('[loadMore] Backend returned 0 items, calling done(empty)');
    resp.done('empty');
    return;
  }

  // Check if no new items were actually added (duplicate UIDs from backend)
  if (currentCount === previousCount) {
    console.log(
      '[loadMore] No new items added (duplicate UIDs), calling done(empty)'
    );
    resp.done('empty');
    return;
  }

  // Check if all new assets were filtered out by client-side filter
  // This happens when filtering by "Groups Only" but backend returned only assets
  const newItemsMatchFilter = Object.values(new_assets).some((item) => {
    if (showFilter.value.value === 'assets') {
      return item.type === 'asset';
    } else if (showFilter.value.value === 'groups') {
      return item.type === 'asset_group';
    }
    return true; // 'all' filter
  });

  console.log('[loadMore] Any new items match filter?', newItemsMatchFilter);
  console.log(
    '[loadMore] New items types:',
    Object.values(new_assets).map((i) => i.type)
  );

  // If we got new items but none match the filter, treat as empty to prevent infinite requests
  if (!newItemsMatchFilter) {
    console.log(
      '[loadMore] No matching items after filter, calling done(empty)'
    );
    resp.done('empty');
  } else {
    console.log('[loadMore] Has matching items, calling done()');
    resp.done();
  }
}

// Auto-fill viewport: Check if the scrollable container is not scrollable
// (items don't fill the viewport) and if so, manually trigger more loading
let autoFillInProgress = false;
async function checkAndAutoFillViewport() {
  if (autoFillInProgress) return;
  autoFillInProgress = true;

  // Give the DOM time to render
  await nextTick();

  // Find the v-infinite-scroll container
  const container = document.querySelector(
    '.assets-layer.layer-active .v-infinite-scroll'
  );
  if (!container) {
    autoFillInProgress = false;
    return;
  }

  // Check if content is shorter than container (no scrollbar needed)
  const needsMoreContent =
    container.scrollHeight <= container.clientHeight + 50;

  if (needsMoreContent) {
    console.log('[autoFill] Viewport not filled, fetching more items...');

    // Create a mock response object for loadMore
    const mockResp = {
      done: (status) => {
        autoFillInProgress = false;
        // If we got more items and still need to fill, check again
        if (status !== 'empty') {
          setTimeout(() => checkAndAutoFillViewport(), 100);
        }
      },
    };

    await loadMore(mockResp);
  } else {
    autoFillInProgress = false;
  }
}
function pruneMismatch(assetsCopy) {
  const searchValue = search.value.toLowerCase(); // Ensure case-insensitive comparison
  for (const asset of Object.values(assetsCopy.assets)) {
    let match = false;

    // Check if the asset's name includes the search value
    const nameMatches = asset.name.toLowerCase().includes(searchValue);

    // Check if any of the tags match the selected filters
    if (selected_filters.value.length > 0) {
      for (const tag of asset.tags) {
        if (selected_filters.value.includes(tag)) {
          match = true;
          break;
        }
      }
    } else {
      match = true; // If no filters are selected, consider it a match
    }

    // Remove the asset if it doesn't match the name or the filters
    if (!nameMatches || !match) {
      delete assetsCopy.assets[asset.uid];
    }
  }
}
watch(
  () => deluge.patch,
  () => {
    // Safety check: ensure deluge.patch exists and has the expected structure
    if (!deluge.patch || !deluge.patch.key || !deluge.patch.data) {
      return;
    }

    if (deluge.patch.key === 'assets') {
      // Handle new assets (add operations) - extract them first
      const addedAssets = (
        Array.isArray(deluge.patch.data)
          ? deluge.patch.data
          : Object.values(deluge.patch.data)
      )
        .filter((patch) => patch.op === 'add')
        .map((patch) => patch.value)
        .filter((asset) => asset && asset.uid); // Ensure asset has uid

      // Apply all patch operations (add, replace, remove, etc.)
      // This handles replace and remove operations correctly
      try {
        applyPatch(assets.value, deluge.patch.data);
      } catch (e) {
        // Patch application failed - ignore and continue
      }

      if (addedAssets.length > 0) {
        // Create a new object with new assets at the top
        // First, remove the newly added assets from the existing object (applyPatch already added them)
        const existingAssets = { ...assets.value.assets };
        for (const asset of addedAssets) {
          delete existingAssets[asset.uid];
        }

        // Rebuild with new assets first (at top), then existing
        assets.value.assets = {
          ...Object.fromEntries(addedAssets.map((asset) => [asset.uid, asset])),
          ...existingAssets,
        };
      }

      // Re-assign indices to all assets to ensure consistent behavior
      // Lowest index = newest (matches API convention)
      const assetArray = Object.values(assets.value.assets || {});
      for (let i = 0; i < assetArray.length; i++) {
        assetArray[i].index = i;
      }

      // Sync changes to breadcrumb_layers so v-virtual-scroll picks them up
      // The virtual scroll uses layer.assets from breadcrumb_layers, not assets.value directly
      if (
        breadcrumb_layers.value &&
        breadcrumb_layers.value[current_layer_index.value]
      ) {
        breadcrumb_layers.value[current_layer_index.value] = {
          ...breadcrumb_layers.value[current_layer_index.value],
          assets: { ...assets.value },
        };
      }
    }
  }
);

watch(
  () => props.forceClose, // swaps between true/false as a way to close dialog from parent (e.g for Cricket app)
  () => {
    asset_info_dialog.value = false;
    selected.value = undefined;
  }
);
const emit = defineEmits(['selected', 'results-count', 'loading']);
const preview_dialog = ref(false);
const selected = ref(undefined);
const files = ref([]);
const over = ref(false);
const filter_dialog = ref(false);
// selected_filters declared earlier
const add_tags = ref([]);
const asset_info_dialog = ref(false);
const selected_assets = ref([]);
const multi_delete_loading = ref(false);
let shift_click_started = false;

// Asset Group related - Breadcrumb Navigation with Cached Layers
const current_group = ref(null); // Current group we're browsing (null = root)
const breadcrumbs = ref([{ name: 'All Assets', uid: null }]); // Navigation breadcrumb trail
const breadcrumb_search_stack = ref([search.value]); // Store search query per breadcrumb level
const breadcrumb_layers = ref([
  { assets: {}, filter: { display_name: 'All', value: 'all' }, search: '' },
]); // Cache each breadcrumb level's data
const current_layer_index = ref(0); // Which layer we're currently viewing
const navigation_direction = ref('forward'); // 'forward' or 'back' for animation direction
const is_transitioning = ref(false); // Track if we're currently animating between layers
const create_group_dialog = ref(false);
const groupDialogMode = ref('create');
const createGroupLoading = ref(false);
const groupDialogInitialName = ref('');
const groupDialogInitialDescription = ref('');
const group_info_dialog = ref(false);
const deleted_assets_dialog = ref(false);
const selected_group = ref(null);
// emit selected if changed
watch(selected, () => {
  emit('selected', selected.value);
});
async function multi_delete() {
  multi_delete_loading.value = true;
  const items = [...selected_assets.value];
  await $http(
    'DELETE',
    '/delete_asset_multi',
    JSON.stringify({ assets: items })
  );
  selected_assets.value = [];
  filterSelection.clearSelection();
  multi_delete_loading.value = false;
  shift_click_started = false;
}

function asset_click_handle(asset) {
  if (!ctrl_down.value && !shift_down.value) {
    selected.value = asset;
    asset_info_dialog.value = true;
  } else if (ctrl_down.value) {
    if (!selected_assets.value.includes(asset.uid)) {
      selected_assets.value.push(asset.uid);
      shift_click_started = asset.uid;
    } else {
      selected_assets.value = selected_assets.value.filter(function (item) {
        return item !== asset.uid;
      });
      if (selected_assets.value.length === 0) {
        shift_click_started = false;
      }
    }
  } else if (shift_down.value) {
    if (shift_click_started) {
      // select assets within range
      const start = assets.value.assets[shift_click_started].index;
      const end = asset.index;
      const asset_list = Object.values(assets.value.assets);
      for (let i = 0; i < asset_list.length; i++) {
        if (
          (asset_list[i].index >= start && asset_list[i].index <= end) ||
          (asset_list[i].index <= start && asset_list[i].index >= end)
        ) {
          if (!selected_assets.value.includes(asset_list[i].uid)) {
            selected_assets.value.push(asset_list[i].uid);
          }
        }
      }
      shift_click_started = false;
    }
    if (!selected_assets.value.includes(asset.uid)) {
      selected_assets.value.push(asset.uid);
    }
    shift_click_started = asset.uid;
  }
}
function get_color_safe(item) {
  if (item) {
    return item.color;
  }
}
function get_name_safe(item) {
  if (item) {
    return item.name;
  }
}
function getAssetIcons(item) {
  const icons = [];

  // Check for ingest source
  if (item.ingest_src) {
    icons.push({ icon: 'mdi-filter-check' });
  }

  // Check for conditions (asset-level conditions for AssetGroup selection)
  if (
    item.conditions?.play_conditions &&
    item.conditions.play_conditions.length > 0
  ) {
    icons.push({ icon: 'mdi-motion-play-outline', color: 'primary' });
  }

  // Note: Removed swap icon for variants - now using formats without conditions
  // Conditional selection is handled via AssetGroups with asset-level conditions

  // Check for optimization status
  if (item.extra_info?.conversion_in_progress) {
    // Grey lightning bolt during conversion
    icons.push({ icon: 'mdi-lightning-bolt', color: 'grey' });
  } else if (
    item.extra_info?.optimizations &&
    item.extra_info.optimizations.length > 0
  ) {
    // Blue lightning bolt when optimized
    icons.push({ icon: 'mdi-lightning-bolt', color: 'primary' });
  }

  return icons;
}
function dropHandler(ev) {
  // Prevent default behavior (Prevent file from being opened)
  ev.preventDefault();

  if (ev.dataTransfer.items) {
    // Use DataTransferItemList interface to access the file(s)
    for (var i = 0; i < ev.dataTransfer.items.length; i++) {
      // If dropped items aren't files, reject them
      if (ev.dataTransfer.items[i].kind === 'file') {
        var file = ev.dataTransfer.items[i].getAsFile();
        files.value.push(file);
      }
    }
  }
  over.value = false;
}
function send_to_upload_queue() {
  const file_input = document.getElementById('asset_file_upload');
  for (const file of file_input.files) {
    state.upload_files.push(file);
  }
  file_input.files = new DataTransfer().files;
}
function open_file_dialog() {
  const file_input = document.getElementById('asset_file_upload');
  file_input.click();
}
function dragOverHandler(ev) {
  over.value = true;
  // Prevent default behavior (Prevent file from being opened)
  ev.preventDefault();
}

// Asset Group Functions - Breadcrumb Navigation with Layer Caching
async function openAssetGroup(group) {
  // Set navigation direction and start transition
  navigation_direction.value = 'forward';
  is_transitioning.value = true;

  // Save current layer state (assets, filter, search) - scroll is preserved automatically
  breadcrumb_layers.value[current_layer_index.value] = {
    assets: { ...assets.value },
    filter: { ...showFilter.value },
    search: search.value,
  };

  // Navigate into the group
  current_group.value = group.uid;
  state.current_asset_group = group.uid;
  breadcrumbs.value.push({
    name: group.name,
    uid: group.uid,
  });

  // Check if we've been to this layer before (cached)
  const nextLayerIndex = breadcrumbs.value.length - 1;
  if (breadcrumb_layers.value[nextLayerIndex]) {
    // Restore cached layer
    current_layer_index.value = nextLayerIndex;
    // Wait for Vue to update DOM, then end transition
    await nextTick();
    setTimeout(() => {
      is_transitioning.value = false;
    }, 300); // Match CSS transition duration
  } else {
    // New layer - create placeholder, then fetch data
    breadcrumb_layers.value[nextLayerIndex] = {
      assets: {},
      filter: { display_name: 'All', value: 'all' },
      search: '',
    };
    current_layer_index.value = nextLayerIndex;
    search.value = '';
    showFilter.value = { display_name: 'All', value: 'all' };

    // Wait for transition to start
    await nextTick();
    setTimeout(() => {
      is_transitioning.value = false;
    }, 300);

    // Fetch data for new layer
    await searchQueryUpdated();
  }
}

async function navigateToGroup(groupUid) {
  // Navigate to specific breadcrumb (going back) - use cached layer
  const targetIndex = breadcrumbs.value.findIndex((b) => b.uid === groupUid);
  if (targetIndex === -1) return;

  // Set navigation direction and start transition
  navigation_direction.value = 'back';
  is_transitioning.value = true;

  // Save current layer state before navigating
  breadcrumb_layers.value[current_layer_index.value] = {
    assets: { ...assets.value },
    filter: { ...showFilter.value },
    search: search.value,
  };

  // Trim breadcrumbs and layers to target level
  breadcrumbs.value = breadcrumbs.value.slice(0, targetIndex + 1);
  breadcrumb_layers.value = breadcrumb_layers.value.slice(0, targetIndex + 1);

  // Update current group
  current_group.value = groupUid;
  state.current_asset_group = groupUid;

  // Update layer index and wait for transition
  current_layer_index.value = targetIndex;

  await nextTick();
  setTimeout(() => {
    is_transitioning.value = false;
  }, 300); // Match CSS transition duration
}

async function navigateBack() {
  // Navigate to parent breadcrumb (go back one level) using cached layer
  if (breadcrumbs.value.length > 1) {
    const parentIndex = breadcrumbs.value.length - 2;
    const parentUid = breadcrumbs.value[parentIndex].uid;
    await navigateToGroup(parentUid);
  }
}

const groupDialogTitle = computed(() =>
  groupDialogMode.value === 'selection'
    ? 'Group Selected Assets'
    : 'Create Asset Group'
);

const groupDialogSubtitle = computed(() =>
  groupDialogMode.value === 'selection'
    ? 'Selected assets will move into this group'
    : 'Name and describe your new group'
);

const groupDialogConfirmLabel = computed(() =>
  groupDialogMode.value === 'selection' ? 'Create & Group' : 'Create'
);

const groupDialogContextMessage = computed(() => {
  if (groupDialogMode.value !== 'selection') {
    return '';
  }

  const count = selected_assets.value.length;
  if (count === 0) {
    return 'Select at least one asset to group.';
  }

  return count === 1
    ? 'The selected asset will be moved into this new group.'
    : `${count} assets will be moved into this new group.`;
});

const groupDialogShowDescription = computed(
  () => groupDialogMode.value !== 'selection'
);

function createNewGroup() {
  groupDialogMode.value = 'create';
  groupDialogInitialName.value = '';
  groupDialogInitialDescription.value = '';
  create_group_dialog.value = true;
}

function openGroupDialogFromSelection() {
  if (selected_assets.value.length === 0) {
    return;
  }

  groupDialogMode.value = 'selection';
  groupDialogInitialName.value = '';
  groupDialogInitialDescription.value = '';
  create_group_dialog.value = true;
}

function handleGroupDialogClose() {
  create_group_dialog.value = false;
}

async function handleGroupDialogSubmit(payload) {
  createGroupLoading.value = true;
  try {
    const response_raw = await $http(
      'POST',
      '/create_asset_group',
      JSON.stringify({
        name: payload.name,
        description: payload.description,
        parent_group_uid: current_group.value,
      })
    );

    const response = JSON.parse(response_raw || '{}');
    const newGroupUid = response?.group?.uid;

    if (groupDialogMode.value === 'selection' && newGroupUid) {
      await addSelectedAssetsToGroup(newGroupUid);
    }

    create_group_dialog.value = false;
    await searchQueryUpdated();
  } catch (error) {
    console.error('Failed to create group:', error);
  } finally {
    createGroupLoading.value = false;
  }
}

async function addSelectedAssetsToGroup(groupUid) {
  const assetUids = selected_assets.value.filter((uid) => {
    const assetRecord = assets.value?.assets?.[uid];
    return assetRecord && assetRecord.type !== 'asset_group';
  });

  for (const assetUid of assetUids) {
    try {
      await $http(
        'PUT',
        '/add_asset_to_group',
        JSON.stringify({
          asset_uid: assetUid,
          group_uid: groupUid,
        })
      );
    } catch (error) {
      console.error(`Failed to add asset ${assetUid} to group`, error);
    }
  }

  if (assetUids.length > 0) {
    selected_assets.value = [];
    shift_click_started = false;
  }
}

function editAssetGroup(group) {
  // Open edit modal for asset group (clicking on card body/name)
  selected_group.value = group;
  group_info_dialog.value = true;
}

function openAssetFromGroup(asset) {
  // When clicking an asset from within the group modal, close group modal and open asset modal
  group_info_dialog.value = false;
  selected.value = asset;
  asset_info_dialog.value = true;
}

function formatGroupThumbnails(thumbnails) {
  // Format thumbnails from backend to include full URLs
  // Backend sends { uid, asset_type, has_static, has_motion } for each asset
  if (!thumbnails || thumbnails.length === 0) {
    return [];
  }

  return thumbnails.map((thumb) => {
    // Construct thumbnail URLs using asset UID (same logic as assetSmallThumbnail())
    const staticUrl = thumb.has_static
      ? `${state.devRedirect}${state.$ident}/thumbnails/previews/static/small/${thumb.uid}.jpg`
      : null;

    const motionUrl =
      thumb.has_motion && thumb.asset_type?.toLowerCase().includes('video')
        ? `${state.devRedirect}${state.$ident}/thumbnails/previews/motion/small/${thumb.uid}.mp4`
        : null;

    return {
      preview_static_small: staticUrl,
      preview_motion_small: motionUrl,
    };
  });
}

// Filter Selection Functions

/**
 * Handle "Select All by Filter" button click.
 * Fetches all UIDs matching current filter and selects them.
 */
async function handleSelectAllByFilter() {
  selectAllLoading.value = true;
  try {
    const { includeAssets, includeGroups } = buildIncludeFilterParams();
    await filterSelection.selectAllByFilter({
      filter_tags: selected_filters.value.join(','),
      search_query: search.value,
      required_tags: requiredTags.value.join(','),
      group_uid: current_group.value || '',
      include_assets: includeAssets,
      include_groups: includeGroups,
    });
    // Sync filter selection to selected_assets for compatibility with existing code
    selected_assets.value = [...filterSelection.selectedUids.value];
  } finally {
    selectAllLoading.value = false;
  }
}

/**
 * Clear filter selection and reset to manual mode.
 */
function handleClearFilterSelection() {
  filterSelection.clearSelection();
  selected_assets.value = [];
  shift_click_started = false;
}

/**
 * Open bulk delete confirmation when using filter selection mode.
 * Always confirm when selecting via "Select All" to prevent accidental mass deletion.
 */
function handleBulkDeleteWithConfirmation() {
  if (filterSelection.selectionMode.value === 'filter') {
    bulkDeleteDialogOpen.value = true;
  } else {
    multi_delete();
  }
}

/**
 * Confirm and execute bulk delete.
 */
async function confirmBulkDelete() {
  await multi_delete();
  bulkDeleteDialogOpen.value = false;
  filterSelection.clearSelection();
}

/**
 * Update visible UIDs when assets load/change.
 * Called after searchQueryUpdated and loadMore.
 */
function updateVisibleUidsFromAssets() {
  const visible = Object.keys(assets.value?.assets || {});
  filterSelection.updateVisibleUids(visible);
}

// Watch assets changes to update visible UIDs
watch(
  () => assets.value?.assets,
  () => {
    updateVisibleUidsFromAssets();
  },
  { deep: true }
);
</script>
<style lang="scss" scoped>
.assets-container {
  overflow-y: auto;
  max-height: calc(
    105vh - 240px
  ); /* Ensure it takes full height of its parent */
  display: flex;
  flex-direction: column;
  height: 100%;
}

.queue_name {
  border-radius: 5px;
  color: white;
  width: 100%;
}
input[type='file'] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
.prim {
  background: blue !important;
}
.blue_hover {
  background: var(--v-titleColor-base);
}
.blue_hover:hover {
  background: var(--v-primary-base);
}

.top-bar-buttons {
  height: 40px !important;
}
.v-infinite-scroll__side {
  display: none !important;
}

/* Custom layer transition system */
.assets-layers-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 240px);
  overflow: hidden;
}

.assets-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
  will-change: transform, opacity;
}

/* Active layer - centered and visible */
.assets-layer.layer-active {
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
}

/* Layers to the left (already visited) - off screen left */
.assets-layer.layer-left {
  transform: translateX(-100%);
  opacity: 0;
  pointer-events: none;
}

/* Layers to the right (not yet visited) - off screen right */
.assets-layer.layer-right {
  transform: translateX(100%);
  opacity: 0;
  pointer-events: none;
}

/* During transition, enable smooth animation */
.assets-layer.layer-transitioning {
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}
</style>
